import { Box, DashboardModuleListItem, Link } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { useRelations, generateUrls } from '@hooks/useProviderPriceList'

import type { ProviderPriceListModel } from '@models/types'
import type { ListItemProps } from '@hooks/useSelectEntities'

interface ProviderPiceListListItemProps extends ListItemProps {
  providerPriceList: ProviderPriceListModel,
}

const ProviderPiceListListItem = (props: ProviderPiceListListItemProps) => {
  const {
    providerPriceList,
    providerPriceList:
    {
      default: priceListDefault,
      id,
      title,
    },
    ...restProps
  } = props

  const {
    provider,
    service,
  } = useRelations(providerPriceList)

  const { editProviderPriceListUrl } = generateUrls({ id })

  const listItemTitle = priceListDefault ? `${title} | Default` : title

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2339
      secondaryText={`${provider?.title} | ${service?.title}`}
      showCheckbox
      title={(
        <Link
          textProps={{ color: 'bodyFontColor' }}
          href={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
        >
          {listItemTitle}
        </Link>
      )}
      {...restProps}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        <Box>
          # {id}
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default ProviderPiceListListItem
